var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87988 15.3301C7.2941 15.3301 7.62988 15.6659 7.62988 16.0801V18.1501C7.62988 18.5643 7.2941 18.9001 6.87988 18.9001C6.46567 18.9001 6.12988 18.5643 6.12988 18.1501V16.0801C6.12988 15.6659 6.46567 15.3301 6.87988 15.3301Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.2598C12.4142 13.2598 12.75 13.5956 12.75 14.0098V18.1498C12.75 18.564 12.4142 18.8998 12 18.8998C11.5858 18.8998 11.25 18.564 11.25 18.1498V14.0098C11.25 13.5956 11.5858 13.2598 12 13.2598Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1201 11.1802C17.5343 11.1802 17.8701 11.516 17.8701 11.9302V18.1502C17.8701 18.5644 17.5343 18.9002 17.1201 18.9002C16.7059 18.9002 16.3701 18.5644 16.3701 18.1502V11.9302C16.3701 11.516 16.7059 11.1802 17.1201 11.1802Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6064 5.27918C17.9217 5.54778 17.9596 6.02115 17.691 6.33646L17.2299 6.87773C14.5782 9.97663 11.0222 12.1703 7.06151 13.1578C6.6596 13.258 6.25255 13.0135 6.15234 12.6116C6.05213 12.2097 6.2967 11.8026 6.69861 11.7024C10.3577 10.79 13.6415 8.76385 16.0898 5.90303C16.0899 5.90285 16.0896 5.90321 16.0898 5.90303L16.5491 5.36376C16.8177 5.04844 17.2911 5.01058 17.6064 5.27918Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4399 5.8501C13.4399 5.43588 13.7757 5.1001 14.1899 5.1001H17.1199C17.5342 5.1001 17.8699 5.43588 17.8699 5.8501V8.7701C17.8699 9.18431 17.5342 9.5201 17.1199 9.5201C16.7057 9.5201 16.3699 9.18431 16.3699 8.7701V6.6001H14.1899C13.7757 6.6001 13.4399 6.26431 13.4399 5.8501Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467ZM4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuDashboard);
export default __webpack_public_path__ + "static/media/ic_menu_dashboard.d69a1dad69e4d7565b96d859dd92f8ea.svg";
export { ForwardRef as ReactComponent };